import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NotFound from './pages/NotFound';
import AudioClips from './pages/AudioClips';
import { AuthProvider, useAuth } from './context/AuthContext'; 
// import { isAuthenticated } from './utils/auth';
import './styles/App.css';

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();
  // Use Outlet to render nested routes like Dashboard
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

const App = () => {
  return (
    <Router>
      <AuthProvider> 
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="login" element={<Login />} />
            <Route path="audio_clips/:id?" element={<AudioClips />} />
            {/* <Route
              path="dashboard"
              element={
                isAuthenticated() ? (
                  <Dashboard />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            /> */}
              <Route element={<ProtectedRoute />}>
                <Route path="dashboard" element={<Dashboard />} />
              </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
